var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "createSellerAccount"
    }
  }, [_c('section', {
    staticClass: "steps"
  }, [_c('Steps')], 1), _vm._v(" "), _c('section', {
    staticClass: "formContainer"
  }, [_c('Step1', {
    ref: "step1"
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }